import { PILLAR, WELL, COUPLING, FOB, CABLE, PON_BOX } from "../Optics/Constants/ConstantsOptics";
import { Snackbar } from '@mui/material';
import CustomSnackbar from "../Optics/Components/CustomSnackbar";
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useState} from "react";
import { RESTORED_ADMIN_COMPONENT_STATUS_API_URL, GET_ADMIN_COMPONENT_ID_API_URL } from "../Optics/OpticApiConfig";
import axios from 'axios';

const AdminAttendance  = ({open, onClose, data }) => {

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg" 
            PaperProps={{
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    padding: '20px',
                    overflowX: 'auto',
                },
            }}
            className="modalStyle"
        >
            <DialogContent>
                
                {data.length > 0 ? (
                    
                    <div className="table-container" >
                    <label >Посещаемость: {data.length} страниц</label>
                    <table className="custom-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Пользователь</th>
                                <th>Роль</th>
                                <th>Страница</th>
                                <th>Дата</th>
                                <th>IP</th>
                                <th>Браузер</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item) => (
                                <tr key={item.id}>
                                    <td>{item.id}</td>
                                    <td>{item.user}</td>
                                    <td>{item.userRoleId}</td>
                                    <td>{item.pageVisited}</td>
                                    <td>{new Date(item.date).toLocaleString()}</td>
                                    <td>{item.ip}</td>
                                    <td>{item.browser}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    </div>
                ) : (
                    <p>Нет данных за выбранную дату</p>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} class="buttonIsHideModal">
                    Закрыть
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AdminAttendance ;